module.exports = __webpack_public_path__ + "img/mtn-white.d091c48c.svg";